/**
 * Public Firebase Web App config. Safe to commit and ship in the
 * client bundle — access is gated by Firebase Auth's "Authorized
 * domains" list and Firestore security rules, not by the apiKey.
 */

import { initializeApp, type FirebaseApp } from "firebase/app";
import { getAuth, type Auth } from "firebase/auth";
import { getFirestore, type Firestore } from "firebase/firestore";
import { getFunctions, type Functions } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyAlo5nJQdiCLe2bFerRbOLJUmDbWOJkkVQ",
  // Firebase Auth handler lives at <authDomain>/__/auth/handler. Using
  // the project's default firebaseapp.com domain is the path Paseo
  // proved works on mobile — popup → Firebase Auth state in browser
  // IndexedDB, no SSR cookie round-trip.
  authDomain: "altajet-vuelos.firebaseapp.com",
  projectId: "altajet-vuelos",
  storageBucket: "altajet-vuelos.firebasestorage.app",
  messagingSenderId: "988472657760",
  appId: "1:988472657760:web:47ee453bfa0e81acdd0005",
};

const app: FirebaseApp = initializeApp(firebaseConfig);

export const auth: Auth = getAuth(app);
export const db: Firestore = getFirestore(app);
// Cloud Functions Gen1 callables default to us-central1; the trigger
// (`createUserDoc`) is auth-region us-east1 — different regions are
// fine for callable vs trigger.
export const functions: Functions = getFunctions(app, "us-central1");

// Workspace domain hint for the Google sign-in flow. Server-side
// enforcement happens in the createUserDoc Cloud Function — this is
// only a UX hint to Google's account chooser.
export const ALLOWED_GOOGLE_DOMAIN = "albinversiones.cl";

export { app };
